import type { DomainMapper } from '../types';

const base = {
  countryCode: 'us',
  currency: 'USD',
  dataAreaId: 'us40',
  environment: 'production',
  flagUrl: '/flags/US.svg',
  languagePrimary: true,
  locale: 'en-us',
  logoUrl: 'kahrs-logo',
  noRobots: false,
  productBasePath: 'product',
  sitemapUrl: 'https://ecom-api.kahrs.com/storage/sitemaps/sitemap-us.xml',
  storyblokBasePath: 'us',
  algoliaIndex: 'b2b-us-en-US-products',
  algoliaIndexAutocomplete: 'b2b-us-en-US-products_query_suggestions',
  algoliaIndexPages: 'content_',
  applicationId: 1357,
  subFolder: true,
  measurement: 'imperial',
  googleSiteVerification: 'tHG4C4vnMgMxfElDcGevBx5-SKSflV4V5W_Rn6Ao8rM',
  b2b: {
    enabled: true,
    purchaseEnabled: true,
    storyblokBasePath: 'b2b',
    applicationId: 1357,
    algoliaIndex: 'b2b-us-en-US-products',
    algoliaIndexAutocomplete: 'b2b-us-en-US-products_query_suggestions',
    displayIncVat: false,
    default: false,
    productBasePath: 'b2b/product',
    sitemapUrl: 'https://ecom-api.kahrs.com/storage/sitemaps/sitemap-us.xml',
  },
  b2c: {
    enabled: true,
    purchaseEnabled: true,
    storyblokBasePath: '',
    applicationId: 1472,
    algoliaIndex: 'b2c-us-en-US-products',
    algoliaIndexAutocomplete: 'b2c-us-en-US-products_query_suggestions',
    displayIncVat: true,
    default: true,
    productBasePath: 'product',
    sitemapUrl: 'https://ecom-api.kahrs.com/storage/sitemaps/sitemap-us-b2c.xml',
  },
  features: {
    fastOrder: true,
    backorders: false,
    cartSettings: true,
    disableShipToConsumer: true,
  },
  showNonPublicProducts: false,
};

const us: DomainMapper[] = ['new.kahrs.com', 'www.kahrs.com'].map((domain) => ({
  ...base,
  domain,
  legacyDomain: domain === 'new.kahrs.com',
  url: `https://${domain}/${base.storyblokBasePath}`,
} as DomainMapper));

export default us;
